import IframeBox from '@/components/iframe_box_ml/IframeBox';

const dgm = () => {
  return <IframeBox src="/systemManage/userManage"></IframeBox>;
};

export default dgm;
